import AstrologerCard from "../UI/AstrologerCard";

export default function AstrologerSlider({
  astrologers = [],
  actionLabel,
  actionTo = "/consult",
  online = false,
  activeCategory = "",
}) {
  return (
    <div className="row g-3 flex-nowrap overflow-auto astro-scroll-row pb-2">
      {astrologers.map((astrologer) => (
        <div
          key={astrologer.id}
          className="col-10 col-sm-6 col-md-4 col-lg-3"
        >
          <AstrologerCard
            astrologer={{
              ...astrologer,
              specialty: activeCategory || astrologer.specialty,
            }}
            actionLabel={actionLabel}
            actionTo={actionTo}
            online={online}
          />
        </div>
      ))}
    </div>
  );
}
